import { h } from '@/lib/dom';
import { toast } from '@/components/Toast';

export function InfoTip(tip: string, ariaContext: string): HTMLElement {
  return h('button', {
    class: 'info-tip',
    type: 'button',
    title: tip,
    'aria-label': `${ariaContext} — методика`,
    on: { click: (ev: Event) => { ev.preventDefault(); toast(tip, { type: 'info', duration: 6000 }); } },
  }, 'ⓘ');
}
